import IState from '@/interfaces/StateMachine/IState';
import BaseFactorBlock from './BaseFactorBlock';

/** 
 * Classe de base d'état d'une machine à état de composant FactorBlock
 * @template TFactorContext Type de FactorBlock spécialisé pour une feature Analysis
 **/
export abstract class BaseFactorState<TFactorContext extends BaseFactorBlock = BaseFactorBlock> implements IState<TFactorContext>{
    /** Contexte de la machine d'etat */
    protected context: TFactorContext;

    /** Changement de contexte
	* @param context Contexte à appliquer
	*/
    public SetContext(context: TFactorContext) {
        this.context = context;
    }
    
    /** Sur l'entrée dans l'etat */
    public abstract Enter(args?: any): void;

    /** Sur sortie de l'état sur application */
    public abstract Next(args?: any): void;

    /** Sur fermeture d'un état */
    public abstract Previous(args?: any) : void;
}